var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveBothDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 41,
    viewBox: "0 0 30 41",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 20,
    width: 24,
    height: 1,
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5467 36.1322L7.30099 29.9732C6.89967 29.5775 6.89967 28.9359 7.30099 28.5401C7.70225 28.1444 8.35295 28.1444 8.75427 28.5401L15 34.6987L21.2458 28.5401C21.6184 28.1726 22.2061 28.1463 22.6094 28.4613L22.699 28.5401C23.1003 28.9357 23.1003 29.5774 22.699 29.9731L16.4522 36.1311L16.4532 36.1322L15 37.5653L13.5467 36.1322Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4533 4.86784L22.699 11.0268C23.1003 11.4225 23.1003 12.0641 22.699 12.4599C22.2977 12.8556 21.6471 12.8556 21.2457 12.4599L15 6.30128L8.75421 12.4599C8.38156 12.8274 7.79393 12.8537 7.39061 12.5387L7.30099 12.4599C6.89967 12.0643 6.89967 11.4226 7.30099 11.0269L13.5478 4.86893L13.5468 4.86784L15 3.43475L16.4533 4.86784Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveBothDown);
export default __webpack_public_path__ + "static/media/move-both-down.8b2aeb5a40ebcbffd5ff0f7a6cc2c505.svg";
export { ForwardRef as ReactComponent };